export const  getDateTime= (dateTime) =>
  {
      let date = dateTime.split(":00.000Z");
      console.log('date[0]');
      console.log(date[0]);

      return date[0];
  }